import ExportedImage from 'next-image-export-optimizer';
import { type ReactNode } from 'react';
import teacherImage from '../../../../public/img/yoko-smile.webp';
import styles from './index.module.scss';

type Props = {
  title?: string;
  children: ReactNode;
};

export const Summary = ({ title = 'この記事の要点', children }: Props) => (
  <div className={styles.base}>
    <div className={styles['icon-container']}>
      <ExportedImage
        src={teacherImage}
        alt="先生"
        className={styles['teacher-icon']}
        width={60}
        height={60}
        loading="lazy"
      />
    </div>
    <div className={styles['speech-bubble']}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </div>
  </div>
);
